module.exports = __webpack_public_path__ + "static/media/plusVector.e987b8ea.svg";